module.exports = __webpack_public_path__ + "img/colordrop-en.19fd2ec.jpg";